export const streetTypeOptions = [
  // AUS & NZL
  { value: 'ACCS', label: 'Access' },
  { value: 'ALLY', label: 'Alley' },
  { value: 'ALWY', label: 'Alleyway' },
  { value: 'AMBL', label: 'Amble' },
  { value: 'ANCG', label: 'Anchorage' },
  { value: 'APP', label: 'Approach' },
  { value: 'ARC', label: 'Arcade' },
  { value: 'ART', label: 'Artery' },
  { value: 'AVE', label: 'Avenue' },
  { value: 'BASN', label: 'Basin' },
  { value: 'BCH', label: 'Beach' },
  { value: 'BEND', label: 'Bend' },
  { value: 'BLK', label: 'Block' },
  { value: 'BVD', label: 'Boulevard' },
  { value: 'BRCE', label: 'Brace' },
  { value: 'BRAE', label: 'Brae' },
  { value: 'BRK', label: 'Break' },
  { value: 'BDGE', label: 'Bridge' },
  { value: 'BDWY', label: 'Broadway' },
  { value: 'BROW', label: 'Brow' },
  { value: 'BYPA', label: 'Bypass' },
  { value: 'BYWY', label: 'Byway' },
  { value: 'CAUS', label: 'Causeway' },
  { value: 'CTR', label: 'Centre' },
  { value: 'CNWY', label: 'Centreway' },
  { value: 'CH', label: 'Chase' },
  { value: 'CIR', label: 'Circle' },
  { value: 'CLT', label: 'Circlet' },
  { value: 'CCT', label: 'Circuit' },
  { value: 'CRCS', label: 'Circus' },
  { value: 'CL', label: 'Close' },
  { value: 'CLDE', label: 'Colonnade' },
  { value: 'CMMN', label: 'Common' },
  { value: 'CON', label: 'Concourse' },
  { value: 'CPS', label: 'Copse' },
  { value: 'CNR', label: 'Corner' },
  { value: 'CSO', label: 'Corso' },
  { value: 'CT', label: 'Court' },
  { value: 'CTYD', label: 'Courtyard' },
  { value: 'COVE', label: 'Cove' },
  { value: 'CRES', label: 'Crescent' },
  { value: 'CRST', label: 'Crest' },
  { value: 'CRSS', label: 'Cross' },
  { value: 'CRSG', label: 'Crossing' },
  { value: 'CRD', label: 'Crossroad' },
  { value: 'COWY', label: 'Crossway' },
  { value: 'CUWY', label: 'Cruiseway' },
  { value: 'CDS', label: 'Cul-De-Sac' },
  { value: 'CTTG', label: 'Cutting' },
  { value: 'DALE', label: 'Dale' },
  { value: 'DELL', label: 'Dell' },
  { value: 'DEVN', label: 'Deviation' },
  { value: 'DIP', label: 'Dip' },
  { value: 'DSTR', label: 'Distributor' },
  { value: 'DR', label: 'Drive' },
  { value: 'DRWY', label: 'Driveway' },
  { value: 'EDGE', label: 'Edge' },
  { value: 'ELB', label: 'Elbow' },
  { value: 'END', label: 'End' },
  { value: 'ENT', label: 'Entrance' },
  { value: 'ESP', label: 'Esplanade' },
  { value: 'EST', label: 'Estate' },
  { value: 'EXP', label: 'Expressway' },
  { value: 'EXTN', label: 'Extension' },
  { value: 'FAWY', label: 'Fairway' },
  { value: 'FTRK', label: 'Fire Track' },
  { value: 'FITR', label: 'Firetrail' },
  { value: 'FLAT', label: 'Flat' },
  { value: 'FOLW', label: 'Follow' },
  { value: 'FTWY', label: 'Footway' },
  { value: 'FSHR', label: 'Foreshore' },
  { value: 'FORM', label: 'Formation' },
  { value: 'FWY', label: 'Freeway' },
  { value: 'FRNT', label: 'Front' },
  { value: 'FRTG', label: 'Frontage' },
  { value: 'GAP', label: 'Gap' },
  { value: 'GDN', label: 'Garden' },
  { value: 'GTE', label: 'Gate' },
  { value: 'GDNS', label: 'Gardens' },
  { value: 'GTES', label: 'Gates' },
  { value: 'GLD', label: 'Glade' },
  { value: 'GLEN', label: 'Glen' },
  { value: 'GRA', label: 'Grange' },
  { value: 'GRN', label: 'Green' },
  { value: 'GRND', label: 'Ground' },
  { value: 'GR', label: 'Grove' },
  { value: 'GLY', label: 'Gully' },
  { value: 'HTS', label: 'Heights' },
  { value: 'HRD', label: 'Highroad' },
  { value: 'HWY', label: 'Highway' },
  { value: 'HILL', label: 'Hill' },
  { value: 'INTG', label: 'Interchange' },
  { value: 'INTN', label: 'Intersection' },
  { value: 'JNC', label: 'Junction' },
  { value: 'KEY', label: 'Key' },
  { value: 'LDG', label: 'Landing' },
  { value: 'LN', label: 'Lane' },
  { value: 'LNWY', label: 'Laneway' },
  { value: 'LEES', label: 'Lees' },
  { value: 'LINE', label: 'Line' },
  { value: 'LINK', label: 'Link' },
  { value: 'LT', label: 'Little' },
  { value: 'LKT', label: 'Lookout' },
  { value: 'LOOP', label: 'Loop' },
  { value: 'LWR', label: 'Lower' },
  { value: 'MALL', label: 'Mall' },
  { value: 'MNDR', label: 'Meander' },
  { value: 'MEW', label: 'Mew' },
  { value: 'MEWS', label: 'Mews' },
  { value: 'MWY', label: 'Motorway' },
  { value: 'MT', label: 'Mount' },
  { value: 'NOOK', label: 'Nook' },
  { value: 'OTLK', label: 'Outlook' },
  { value: 'PDE', label: 'Parade' },
  { value: 'PARK', label: 'Park' },
  { value: 'PKLD', label: 'Parklands' },
  { value: 'PKWY', label: 'Parkway' },
  { value: 'PART', label: 'Part' },
  { value: 'PASS', label: 'Pass' },
  { value: 'PSGE', label: 'Passage' },
  { value: 'PATH', label: 'Path' },
  { value: 'PHWY', label: 'Pathway' },
  { value: 'PIAZ', label: 'Piazza' },
  { value: 'PL', label: 'Place' },
  { value: 'PLAT', label: 'Plateau' },
  { value: 'PLZA', label: 'Plaza' },
  { value: 'PKT', label: 'Pocket' },
  { value: 'PNT', label: 'Point' },
  { value: 'PORT', label: 'Port' },
  { value: 'PROM', label: 'Promenade' },
  { value: 'QUAD', label: 'Quad' },
  { value: 'QDGL', label: 'Quadrangle' },
  { value: 'QDRT', label: 'Quadrant' },
  { value: 'QY', label: 'Quay' },
  { value: 'QYS', label: 'Quays' },
  { value: 'RMBL', label: 'Ramble' },
  { value: 'RAMP', label: 'Ramp' },
  { value: 'RNGE', label: 'Range' },
  { value: 'RCH', label: 'Reach' },
  { value: 'RES', label: 'Reserve' },
  { value: 'REST', label: 'Rest' },
  { value: 'RTT', label: 'Retreat' },
  { value: 'RIDE', label: 'Ride' },
  { value: 'RDGE', label: 'Ridge' },
  { value: 'RGWY', label: 'Ridgeway' },
  { value: 'ROWY', label: 'Right of way' },
  { value: 'RING', label: 'Ring' },
  { value: 'RISE', label: 'Rise' },
  { value: 'RVR', label: 'River' },
  { value: 'RVWY', label: 'Riverway' },
  { value: 'RVRA', label: 'Riviera' },
  { value: 'RD', label: 'Road' },
  { value: 'RDS', label: 'Roads' },
  { value: 'RDSD', label: 'Roadside' },
  { value: 'RDWY', label: 'Roadway' },
  { value: 'RNDE', label: 'Ronde' },
  { value: 'RSBL', label: 'Rosebowl' },
  { value: 'RTY', label: 'Rotary' },
  { value: 'RND', label: 'Round' },
  { value: 'RTE', label: 'Route' },
  { value: 'ROW', label: 'Row' },
  { value: 'RUE', label: 'Rue' },
  { value: 'RUN', label: 'Run' },
  { value: 'SWY', label: 'Service way' },
  { value: 'SDNG', label: 'Siding' },
  { value: 'SLPE', label: 'Slope' },
  { value: 'SND', label: 'Sound' },
  { value: 'SPUR', label: 'Spur' },
  { value: 'SQ', label: 'Square' },
  { value: 'STRS', label: 'Stairs' },
  { value: 'SHWY', label: 'State highway' },
  { value: 'STPS', label: 'Steps' },
  { value: 'STRA', label: 'Strand' },
  { value: 'ST', label: 'Street' },
  { value: 'STRP', label: 'Strip' },
  { value: 'SBWY', label: 'Subway' },
  { value: 'TARN', label: 'Tarn' },
  { value: 'TCE', label: 'Terrace' },
  { value: 'THOR', label: 'Thoroughfare' },
  { value: 'TLWY', label: 'Tollway' },
  { value: 'TOP', label: 'Top' },
  { value: 'TOR', label: 'Tor' },
  { value: 'TWRS', label: 'Towers' },
  { value: 'TRK', label: 'Track' },
  { value: 'TRL', label: 'Trail' },
  { value: 'TRLR', label: 'Trailer' },
  { value: 'TRI', label: 'Triangle' },
  { value: 'TKWY', label: 'Trunkway' },
  { value: 'TURN', label: 'Turn' },
  { value: 'UPAS', label: 'Underpass' },
  { value: 'UPR', label: 'Upper' },
  { value: 'VALE', label: 'Vale' },
  { value: 'VDCT', label: 'Viaduct' },
  { value: 'VIEW', label: 'View' },
  { value: 'VLLS', label: 'Villas' },
  { value: 'VSTA', label: 'Vista' },
  { value: 'WADE', label: 'Wade' },
  { value: 'WALK', label: 'Walk' },
  { value: 'WKWY', label: 'Walkway' },
  { value: 'WAY', label: 'Way' },
  { value: 'WHRF', label: 'Wharf' },
  { value: 'WYND', label: 'Wind' },
];

export const streetTypeOptionsUSA = [
  // USA
  { value: 'ACCS', label: 'Access' },
  { value: 'ALLY', label: 'Alley' },
  { value: 'AMBL', label: 'Amble' },
  { value: 'ANCG', label: 'Anchorage' },
  { value: 'APP', label: 'Approach' },
  { value: 'ARC', label: 'Arcade' },
  { value: 'ART', label: 'Artery' },
  { value: 'AVE', label: 'Avenue' },
  { value: 'BASN', label: 'Basin' },
  { value: 'BCH', label: 'Beach' },
  { value: 'BEND', label: 'Bend' },
  { value: 'BLK', label: 'Block' },
  { value: 'BVD', label: 'Boulevard' },
  { value: 'BRCE', label: 'Brace' },
  { value: 'BRAE', label: 'Brae' },
  { value: 'BRK', label: 'Break' },
  { value: 'BDGE', label: 'Bridge' },
  { value: 'BDWY', label: 'Broadway' },
  { value: 'BROW', label: 'Brow' },
  { value: 'BYPA', label: 'Bypass' },
  { value: 'BYWY', label: 'Byway' },
  { value: 'CAUS', label: 'Causeway' },
  { value: 'CTR', label: 'Centre' },
  { value: 'CNWY', label: 'Centreway' },
  { value: 'CH', label: 'Chase' },
  { value: 'CIR', label: 'Circle' },
  { value: 'CLT', label: 'Circlet' },
  { value: 'CCT', label: 'Circuit' },
  { value: 'CRCS', label: 'Circus' },
  { value: 'CL', label: 'Close' },
  { value: 'CLDE', label: 'Colonnade' },
  { value: 'CMMN', label: 'Common' },
  { value: 'CON', label: 'Concourse' },
  { value: 'CPS', label: 'Copse' },
  { value: 'CNR', label: 'Corner' },
  { value: 'CSO', label: 'Corso' },
  { value: 'CT', label: 'Court' },
  { value: 'CTYD', label: 'Courtyard' },
  { value: 'COVE', label: 'Cove' },
  { value: 'CRES', label: 'Crescent' },
  { value: 'CRST', label: 'Crest' },
  { value: 'CRSS', label: 'Cross' },
  { value: 'CRSG', label: 'Crossing' },
  { value: 'CRD', label: 'Crossroad' },
  { value: 'COWY', label: 'Crossway' },
  { value: 'CUWY', label: 'Cruiseway' },
  { value: 'CDS', label: 'Cul-de-sac' },
  { value: 'CTTG', label: 'Cutting' },
  { value: 'DALE', label: 'Dale' },
  { value: 'DELL', label: 'Dell' },
  { value: 'DEVN', label: 'Deviation' },
  { value: 'DIP', label: 'Dip' },
  { value: 'DSTR', label: 'Distributor' },
  { value: 'DR', label: 'Drive' },
  { value: 'DRWY', label: 'Driveway' },
  { value: 'EDGE', label: 'Edge' },
  { value: 'ELB', label: 'Elbow' },
  { value: 'END', label: 'End' },
  { value: 'ENT', label: 'Entrance' },
  { value: 'ESP', label: 'Esplanade' },
  { value: 'EST', label: 'Estate' },
  { value: 'EXP', label: 'Expressway' },
  { value: 'EXTN', label: 'Extension' },
  { value: 'FAWY', label: 'Fairway' },
  { value: 'FTRK', label: 'Fire track' },
  { value: 'FITR', label: 'Firetrail' },
  { value: 'FLAT', label: 'Flat' },
  { value: 'FOLW', label: 'Follow' },
  { value: 'FTWY', label: 'Footway' },
  { value: 'FSHR', label: 'Foreshore' },
  { value: 'FORM', label: 'Formation' },
  { value: 'FWY', label: 'Freeway' },
  { value: 'FRNT', label: 'Front' },
  { value: 'FRTG', label: 'Frontage' },
  { value: 'GAP', label: 'Gap' },
  { value: 'GDN', label: 'Garden' },
  { value: 'GTE', label: 'Gate' },
  { value: 'GLD', label: 'Glade' },
  { value: 'GLEN', label: 'Glen' },
  { value: 'GRA', label: 'Grange' },
  { value: 'GRN', label: 'Green' },
  { value: 'GRND', label: 'Ground' },
  { value: 'GR', label: 'Grove' },
  { value: 'GLY', label: 'Gully' },
  { value: 'HTS', label: 'Heights' },
  { value: 'HRD', label: 'Highroad' },
  { value: 'HWY', label: 'Highway' },
  { value: 'HILL', label: 'Hill' },
  { value: 'INTG', label: 'Interchange' },
  { value: 'INTN', label: 'Intersection' },
  { value: 'JNC', label: 'Junction' },
  { value: 'KEY', label: 'Key' },
  { value: 'LDG', label: 'Landing' },
  { value: 'LN', label: 'Lane' },
  { value: 'LNWY', label: 'Laneway' },
  { value: 'LEES', label: 'Lees' },
  { value: 'LINE', label: 'Line' },
  { value: 'LINK', label: 'Link' },
  { value: 'LT', label: 'Little' },
  { value: 'LKT', label: 'Lookout' },
  { value: 'LOOP', label: 'Loop' },
  { value: 'LWR', label: 'Lower' },
  { value: 'MALL', label: 'Mall' },
  { value: 'MNDR', label: 'Meander' },
  { value: 'MEW', label: 'Mew' },
  { value: 'MWY', label: 'Motorway' },
  { value: 'MT', label: 'Mount' },
  { value: 'NOOK', label: 'Nook' },
  { value: 'OTLK', label: 'Outlook' },
  { value: 'PDE', label: 'Parade' },
  { value: 'PARK', label: 'Park' },
  { value: 'PKLD', label: 'Parklands' },
  { value: 'PKWY', label: 'Parkway' },
  { value: 'PART', label: 'Part' },
  { value: 'PASS', label: 'Pass' },
  { value: 'PSGE', label: 'Passage' },
  { value: 'PATH', label: 'Path' },
  { value: 'PHWY', label: 'Pathway' },
  { value: 'PIAZ', label: 'Piazza' },
  { value: 'PL', label: 'Place' },
  { value: 'PLAT', label: 'Plateau' },
  { value: 'PLZA', label: 'Plaza' },
  { value: 'PKT', label: 'Pocket' },
  { value: 'PNT', label: 'Point' },
  { value: 'PORT', label: 'Port' },
  { value: 'PROM', label: 'Promenade' },
  { value: 'QUAD', label: 'Quad' },
  { value: 'QDGL', label: 'Quadrangle' },
  { value: 'QDRT', label: 'Quadrant' },
  { value: 'QY', label: 'Quay' },
  { value: 'RMBL', label: 'Ramble' },
  { value: 'RAMP', label: 'Ramp' },
  { value: 'RNGE', label: 'Range' },
  { value: 'RCH', label: 'Reach' },
  { value: 'RES', label: 'Reserve' },
  { value: 'REST', label: 'Rest' },
  { value: 'RTT', label: 'Retreat' },
  { value: 'RIDE', label: 'Ride' },
  { value: 'RDGE', label: 'Ridge' },
  { value: 'RGWY', label: 'Ridgeway' },
  { value: 'ROWY', label: 'Right of way' },
  { value: 'RING', label: 'Ring' },
  { value: 'RISE', label: 'Rise' },
  { value: 'RVR', label: 'River' },
  { value: 'RVWY', label: 'Riverway' },
  { value: 'RVRA', label: 'Riviera' },
  { value: 'RD', label: 'Road' },
  { value: 'RDSD', label: 'Roadside' },
  { value: 'RDWY', label: 'Roadway' },
  { value: 'RNDE', label: 'Ronde' },
  { value: 'RSBL', label: 'Rosebowl' },
  { value: 'RTY', label: 'Rotary' },
  { value: 'RND', label: 'Round' },
  { value: 'RTE', label: 'Route' },
  { value: 'ROW', label: 'Row' },
  { value: 'RUE', label: 'Rue' },
  { value: 'RUN', label: 'Run' },
  { value: 'SWY', label: 'Service way' },
  { value: 'SDNG', label: 'Siding' },
  { value: 'SLPE', label: 'Slope' },
  { value: 'SND', label: 'Sound' },
  { value: 'SPUR', label: 'Spur' },
  { value: 'SQ', label: 'Square' },
  { value: 'STRS', label: 'Stairs' },
  { value: 'SHWY', label: 'State highway' },
  { value: 'STPS', label: 'Steps' },
  { value: 'STRA', label: 'Strand' },
  { value: 'ST', label: 'Street' },
  { value: 'STRP', label: 'Strip' },
  { value: 'SBWY', label: 'Subway' },
  { value: 'TARN', label: 'Tarn' },
  { value: 'TCE', label: 'Terrace' },
  { value: 'THOR', label: 'Thoroughfare' },
  { value: 'TLWY', label: 'Tollway' },
  { value: 'TOP', label: 'Top' },
  { value: 'TOR', label: 'Tor' },
  { value: 'TWRS', label: 'Towers' },
  { value: 'TRK', label: 'Track' },
  { value: 'TRL', label: 'Trail' },
  { value: 'TRLR', label: 'Trailer' },
  { value: 'TRI', label: 'Triangle' },
  { value: 'TKWY', label: 'Trunkway' },
  { value: 'TURN', label: 'Turn' },
  { value: 'UPAS', label: 'Underpass' },
  { value: 'UPR', label: 'Upper' },
  { value: 'VALE', label: 'Vale' },
  { value: 'VDCT', label: 'Viaduct' },
  { value: 'VIEW', label: 'View' },
  { value: 'VLLS', label: 'Villas' },
  { value: 'VSTA', label: 'Vista' },
  { value: 'WADE', label: 'Wade' },
  { value: 'WALK', label: 'Walk' },
  { value: 'WKWY', label: 'Walkway' },
  { value: 'WAY', label: 'Way' },
  { value: 'WHRF', label: 'Wharf' },
  { value: 'WYND', label: 'Wind' },
  { value: 'ANEX', label: 'Anex' },
  { value: 'BAYOO', label: 'Bayou' },
  { value: 'BLF', label: 'Bluff' },
  { value: 'BOT', label: 'Bottom' },
  { value: 'BR', label: 'Branch' },
  { value: 'BRK', label: 'Brook' },
  { value: 'BURG', label: 'Burg' },
  { value: 'CAMP', label: 'Camp' },
  { value: 'CANYN', label: 'Canyon' },
  { value: 'CAPE', label: 'Cape' },
  { value: 'CEN', label: 'Center' },
  { value: 'CLF', label: 'Cliff' },
  { value: 'CLB', label: 'Club' },
  { value: 'COURSE', label: 'Course' },
  { value: 'CREEK', label: 'Creek' },
  { value: 'CURVE', label: 'Curve' },
  { value: 'DAM', label: 'Dam' },
  { value: 'DIV', label: 'Divide' },
  { value: 'FALL', label: 'Fall' },
  { value: 'FERRY', label: 'Ferry' },
  { value: 'FIELD', label: 'Field' },
  { value: 'FORD', label: 'Ford' },
  { value: 'FOREST', label: 'Forest' },
  { value: 'FORG', label: 'Forge' },
  { value: 'FORK', label: 'Fork' },
  { value: 'FORT', label: 'Fort' },
  { value: 'GATEWAY', label: 'Gateway' },
  { value: 'HARB', label: 'Harbor' },
  { value: 'HAVEN', label: 'Haven' },
  { value: 'HLLW', label: 'Hollow' },
  { value: 'INLT', label: 'Inlet' },
  { value: 'IS', label: 'Island' },
  { value: 'ISLE', label: 'Isle' },
  { value: 'KNL', label: 'Knoll' },
  { value: 'LK', label: 'Lake' },
  { value: 'LAND', label: 'Land' },
  { value: 'LGT', label: 'Light' },
  { value: 'LF', label: 'Loaf' },
  { value: 'LCK', label: 'Lock' },
  { value: 'LDG', label: 'Lodge' },
  { value: 'MNR', label: 'Manor' },
  { value: 'MEADOW', label: 'Meadow' },
  { value: 'MILL', label: 'Mill' },
  { value: 'MISSN', label: 'Mission' },
  { value: 'MNTAIN', label: 'Mountain' },
  { value: 'NCK', label: 'Neck' },
  { value: 'ORCH', label: 'Orchard' },
  { value: 'OVAL', label: 'Oval' },
  { value: 'OVERPASS', label: 'Overpass' },
  { value: 'PIKE', label: 'Pike' },
  { value: 'PINE', label: 'Pine' },
  { value: 'PLAIN', label: 'Plain' },
  { value: 'PR', label: 'Prairie' },
  { value: 'RAD', label: 'Radial' },
  { value: 'RANCH', label: 'Ranch' },
  { value: 'RAPID', label: 'Rapid' },
  { value: 'SHL', label: 'Shoal' },
  { value: 'SHOAR', label: 'Shore' },
  { value: 'SKYWAY', label: 'Skyway' },
  { value: 'SPG', label: 'Spring' },
  { value: 'STA', label: 'Station' },
  { value: 'STRA', label: 'Stravenue' },
  { value: 'STREAM', label: 'Stream' },
  { value: 'SMT', label: 'Summit' },
  { value: 'THROUGHWAY', label: 'Throughway' },
  { value: 'TRACE', label: 'Trace' },
  { value: 'TRAFFICWAY', label: 'Trafficway' },
  { value: 'TUNEL', label: 'Tunnel' },
  { value: 'TRNPK', label: 'Turnpike' },
  { value: 'UN', label: 'Union' },
  { value: 'VALLEY', label: 'Valley' },
  { value: 'VILL', label: 'Village' },
  { value: 'VILLE', label: 'Ville' },
  { value: 'WALL', label: 'Wall' },
  { value: 'WELL', label: 'Well' },
];
